import React from "react";
import "./Third.css";
import { Container } from "react-bootstrap";
import artWork from "../../../../Asset/d2c/Artwork-1.png"
const Third = () => {
  return (
    <>
      <section className="third-d2c-section">
        <Container>
          <div className="text_wrap">
            <h2>
              D2C ECommerce for <strong> your brand</strong>
            </h2>
            <p>
              Direct-to-Consumer (D2C) eCommerce involves brands selling their
              products directly to customers online, bypassing traditional
              retail intermediaries. India's D2C market is booming, with
              countless brands going online.
            </p>
            <p>
              D2C business model allows you to build direct relationships with
              your customes, that foster loyalty and engagement. Elimination of
              middleman maximise your profit margins and gives you complete
              control over your brand's image and customer experience.{" "}
            </p>
            <p>
              It allows you to do more than just selling products. It helps you
              create experiences, build relationships, and shape your brand's
              future.
            </p>
          </div>
          <div className="art-work-img">
            <img alt="art-work" src={artWork} className="w-100" />
          </div>
        </Container>
      </section>
    </>
  );
};

export default Third;
